import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// Ответ 202 с pending=true — правка автора ушла в очередь одобрения, в БД её ещё нет
export const isSubmissionResponse = response => Boolean(
  response && response.status === 202 && response.data && response.data.pending === true,
)

export const notifySubmitted = (toast, message = 'Отправлено на одобрение') => toast({
  component: ToastificationContent,
  props: { title: message, icon: 'ClockIcon', variant: 'warning' },
})

export const SUBMISSION_STATUS_VARIANTS = {
  pending: 'warning',
  approved: 'success',
  rejected: 'danger',
}

export const SUBMISSION_TYPE_OPTIONS = [
  { value: '', text: 'Все типы' },
  { value: 'album_cover', text: 'Обложки' },
  { value: 'track', text: 'Треки' },
  { value: 'cover_link', text: 'Каверы' },
  { value: 'photo', text: 'Фото' },
  { value: 'members', text: 'Составы' },
  { value: 'similar', text: 'Похожие' },
]

export const SUBMISSION_STATUS_OPTIONS = [
  { value: 'pending', text: 'На одобрении' },
  { value: 'approved', text: 'Одобрено' },
  { value: 'rejected', text: 'Отклонено' },
]

// Связь кавер→оригинал на трек, который только что ушёл на одобрение. Заявка на трек уже создана,
// поэтому сбой связи не должен её прятать: вызывать ПОСЛЕ уведомления о заявке, ошибку — отдельным тостом
export const createCoverLinkAfterSubmission = async (store, toast, payload) => {
  try {
    await store.dispatch('moderation/createCoverLink', payload)
    return true
  } catch (error) {
    const reason = (error.response && error.response.data && error.response.data.message) || error.message || 'неизвестная ошибка'
    toast({
      component: ToastificationContent,
      props: {
        title: `Трек отправлен на одобрение, но связь с кавером не создана: ${reason}`,
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    })
    return false
  }
}
